module.exports = __webpack_public_path__ + "img/_australia.19228553.png";